import CoverSetting from '@components/Hotel/CoverSetting'
import AlbumManage from '@components/Hotel/AlbumManage'
import SiteManage from '@components/Hotel/SiteManage'
import SiteRanking from '@components/Hotel/SiteRanking'
import WeddingHallEdit from '@components/Hotel/WeddingHall/Edit'
import MenuManage from '@components/Hotel/MenuManage'
import MenuRanking from '@components/Hotel/MenuRanking'
import CreateMenu from '@components/Hotel/CreateMenu'

import CalendarMode from '@components/Hotel/CalendarMode'
import ListMode from '@components/Hotel/ListMode'

// import ExclusiveOffers from '@components/Hotel/ExclusiveOffers'
import ExclusiveDiscount from '@components/Hotel/ExclusiveDiscount'
import UniqueInfo from '@components/Hotel/UniqueInfo'

import MyOrder from '@components/Hotel/MyOrder'
import MyOrder_main from '@components/Hotel/MyOrder/MyOrder_main'
import MyOrder_info from '@components/Hotel/MyOrder/MyOrder_info'

import OrderFeedback from '@components/Hotel/OrderFeedback'

import Manage from '@components/Hotel/SettlementManage'
import Home from '@components/Hotel/SettlementManage/Home'
import History from '@components/Hotel/SettlementManage/History'
import Detail from '@components/Hotel/SettlementManage/Detail'

import Cashier from '@components/Hotel/Cashier'
import Remittance from '@components/Hotel/Cashier/Remittance'
import { asyncLoad } from '@util'

/**
 * 酒店子账号路由
 */
export default [
  {
    path: 'albumManage',
    component: AlbumManage
  },
  {
    path: 'siteManage',
    indexRoute: {
      component: SiteManage
    },
    moduleName: '场地管理',
    childRoutes: [
      {
        path: 'siteRanking',
        component: SiteRanking
      },
      {
        path: 'editWeddingHall(/:id)',
        component: WeddingHallEdit,
        title: '发布宴会厅'
      }
    ]
  },
  {
    path: 'menuManage',
    indexRoute: {
      component: MenuManage
    },
    childRoutes: [
      {
        path: 'menuRanking',
        component: MenuRanking
      },
      {
        path: 'createMenu',
        component: CreateMenu
      },
      {
        path: 'editMenu/:id',
        component: CreateMenu
      }
    ]
  },
  {
    path: 'mealManage',
    indexRoute: {
      component: asyncLoad(() => import('@components/Hotel/MealManage/Home'))
    },
    stat: '套餐管理/首页',
    moduleName: '套餐管理',
    childRoutes: [
      {
        path: 'create',
        component: asyncLoad(() =>
          import('@components/Hotel/MealManage/CreateOrUpdateMeal')
        ),
        stat: '套餐管理/发布套餐',
        title: '发布套餐'
      },
      {
        path: 'edit(/:id)',
        component: asyncLoad(() =>
          import('@components/Hotel/MealManage/CreateOrUpdateMeal')
        ),
        stat: '套餐管理/编辑套餐',
        title: '编辑套餐'
      },
      {
        path: 'draftBox',
        component: asyncLoad(() =>
          import('@components/Hotel/MealManage/DraftBox')
        ),
        stat: '套餐管理/草稿箱',
        title: '草稿箱'
      },
      {
        path: 'review',
        component: asyncLoad(() =>
          import('@components/Hotel/MealManage/Review')
        ),
        stat: '套餐管理/套餐审核记录',
        title: '套餐审核记录'
      }
    ]
  },
  {
    path: 'calendarMode',
    component: CalendarMode
  },
  {
    path: 'listMode',
    component: ListMode
  },
  {
    path: 'hotelInfoBasic',
    component: CoverSetting
  },
  {
    path: 'coverSetting',
    component: CoverSetting
  },
  {
    path: 'exclusiveOffers',
    component: ExclusiveDiscount
  },
  {
    path: 'uniqueInfo',
    component: UniqueInfo
  },

  {
    path: 'myOrder',
    component: MyOrder,
    indexRoute: {
      component: MyOrder_main
    },
    childRoutes: [
      {
        path: 'info/:id',
        component: MyOrder_info
      }
    ]
  },
  {
    path: 'orderFeedback',
    component: OrderFeedback
  },
  {
    path: 'settlementManage',
    component: Manage,
    indexRoute: {
      component: Home
    },
    childRoutes: [
      {
        path: 'history',
        component: History
      },
      {
        path: 'detail/:id',
        component: Detail
      }
    ]
  },
  {
    path: 'hoterCashier',
    component: Cashier
  },
  {
    path: 'hoterCashier/remittance',
    component: Remittance
  }
]
